module.exports = __webpack_public_path__ + "static/img/xj.caff634.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/xj.png
// module id = QIDH
// module chunks = 37